import { render } from "./CardSpotDetails.vue?vue&type=template&id=4e619be2&scoped=true"
import script from "./CardSpotDetails.vue?vue&type=script&lang=js"
export * from "./CardSpotDetails.vue?vue&type=script&lang=js"

import "./CardSpotDetails.vue?vue&type=style&index=0&id=4e619be2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e619be2"]])

export default __exports__